import { render, staticRenderFns } from "./DeleteUserFromRegion.vue?vue&type=template&id=2e54937d"
import script from "./DeleteUserFromRegion.vue?vue&type=script&lang=js"
export * from "./DeleteUserFromRegion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports